import { createBackendAPI } from "./client/backendApi";
import { AxiosResponse } from "axios";

class ServiceBrokerCaller {

  public static async callService(serviceName: string, data: Record<string, unknown>): Promise<Record<string, unknown> | null> {
    const { context, service } = this.resolveServiceContext(serviceName);

    const backend = createBackendAPI(context);
    const config = this.getErpConfig(service);

    return backend
      .post('service.sbr', data, config)
      .then(response => this.resolveErpReponse(response, serviceName));
  }

  private static resolveErpReponse(response: AxiosResponse, serviceName: string): Record<string, unknown> | null {
    const HTTP_SERVICE_BROKER_ERROR_CODES = [0, 3, 4];
    const serviceBrokerStatus = response?.data?.status;

    if (HTTP_SERVICE_BROKER_ERROR_CODES.includes(serviceBrokerStatus)) {
      console.error(`[ServiceBrokerCaller - callService()] Erro ao chamar serviço ${serviceName}. Status: ${serviceBrokerStatus}`, response.data);
      throw new Error(`[ServiceBrokerCaller - callService()] Erro ao chamar serviço ${serviceName}. Status: ${serviceBrokerStatus}`);
    }

    return response?.data?.responseBody ?? null;
  }

  private static getErpConfig(service: string) {
    return {
      params: {
        outputType: 'json',
        preventTransform: false,
        application: 'devex-jnm-webcom81-webcomponents',
        mgeSession: this.getSession() || (window as Window & { mgeSession?: string })['mgeSession'],
        serviceName: service
      }
    };
  }

  private static getSession() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("mgeSession");
  }

  private static resolveServiceContext(serviceName: string): { context: string; service: string } {

    if (serviceName.indexOf("@") == -1) {
      return { context: "mge", service: serviceName };
    }

    const [contextName, service] = serviceName.split("@");

    return { context: contextName, service };
  }

}

export default ServiceBrokerCaller;
